<template>
  <div class="confirm">
    <div class="confirm__container">
      <h1 class="h4 confirm__container__header">Buchungsbestätigung</h1>
      <h2 class="h3 success__title">Ihr Termin wurde erfolgreich gebucht!</h2>
      <p class="success__subtitle">
        Sie finden alle Details auf der nachfolgenden Übersichtseite, dort können Sie den Termin bei
        Bedarf auch stornieren. Wir freuen uns sehr auf Ihren Besuch!
      </p>
      
      <!-- Display all appointments -->
      <div 
        v-for="(appointment, index) in currentAppointments" 
        :key="appointment.id || index"
        class="confirm__container__summary">
        <div class="">
          <p class="confirm__container__summary__header">
            {{
              formatDateTime('day, dateShort', appointment?.von) +
              ' • ' +
              appointment?.snrBezeichnung
            }}
          </p>
          <p class="confirm__container__summary__detail">
            {{
              appointment?.dienststelleModel.bezeichnung +
              ' • ' +
              appointment?.terminFahrzeugModel.marke +
              ' ' +
              appointment?.terminFahrzeugModel.typ
            }}
          </p>
          <p class="confirm__container__summary__detail">
            {{
              formatDateTime(
                'timeFrom - timeUntil Uhr',
                appointment?.von,
                appointment?.bis
              )
            }}
            • Dauer: {{ getDuration(appointment?.von, appointment?.bis) }}
          </p>
        </div>
        <div class="confirm__container__summary__btns">
          <Button 
            label="In Kalender exportieren" 
            outline 
            @clicked="exportToCalendar(appointment.id)" />
        </div>
      </div>

      <ConsultationBooking />

      <div class="confirm__container__btns">
        <Button label="Zur Übersicht" @clicked="navigateToHome" />
      </div>
    </div>
  </div>
</template>

<script setup>
import ConsultationBooking from '@/components/Booking/ConsultationBooking.vue'
import Button from '@/components/Button.vue'
import { computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { formatDateTime, getDuration } from '../utils/format'

const store = useStore()
const route = useRoute()
const router = useRouter()

const currentAppointments = computed(() => store.getters['currentAppointments'])
// Backward compatibility: use first appointment for routing
const currentAppointment = computed(() => store.getters['currentAppointment'])

const appointmentId = computed(() => currentAppointment.value?.id)

const routeParam = computed(() => route.params.appointmentId)

onMounted(() => {
  if (!routeParam.value || !appointmentId.value) {
    console.warn('No appointment ID found, redirecting to home')
    router.push({ name: 'Home' })
    return
  }
})

function exportToCalendar(appointmentId) {
  store.dispatch('exportAppointment', appointmentId)
}

function navigateToHome() {
  // Use the first appointment ID for navigation
  router.push({ name: 'AppointmentId', params: { appointmentId: appointmentId.value } })
}
</script>

<style lang="scss">
.confirm {
  @include flex-center-align;
  flex-direction: column;
  background-color: $color-grey-lightest;

  &__container {
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: 4px;
    margin: 64px 0;
    max-width: 856px;
    padding: 32px 72px 40px;
    width: 100%;
    min-height: 75vh;

    > hr {
      margin: 40px -72px;
      width: auto;
    }

    @media (max-width: 856px) {
      border-radius: 0;
      margin: 0;
    }

    @media (max-width: $breakpoint-max-tablet) {
      padding: 32px 32px 40px;
    }

    @media (max-width: $breakpoint-max-mobile) {
      padding: 0 16px 48px;
    }

    &__header {
      margin-bottom: 48px;
    }

    &__summary {
      padding: 12px;
      border: 1px solid $color-grey-light;
      border-radius: 4px;

			&:not(:last-child) {
				margin-bottom: 16px;
			}

      &__header {
        font-weight: $font-weight-bold;
      }

      &__detail {
        color: $color-text-secondary;
        margin-top: 4px;
      }

      &__btns {
        margin-top: 16px;
      }
    }

    &__btns {
      margin-top: 24px;
      display: flex;
      justify-content: stretch;

      .button {
        width: 100%;
      }

      @media (min-width: $breakpoint-mobile) {
        justify-content: flex-end;
        .button {
          width: inherit;
        }
      }
    }
  }

  .success {
    &__title {
      font-weight: $font-weight-medium;
      margin-bottom: 8px;
      font-size: 16px;
      line-height: $line-height;
    }

    &__subtitle {
      color: $color-text-secondary;
      margin-bottom: 24px;
    }
  }

  &__container__consultation {
    margin-top: 32px;

    .consultation {
      &__header {
        font-weight: $font-weight-bold;
        margin-bottom: 8px;
      }

      &__intro {
        color: $color-text-secondary;
        margin-bottom: 16px;
      }
    }
  }
}
</style>
